import { ErrorHandler, NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '@app/app.routing.module';
import { AppContainer } from '@app/app.container';
import { CoreModule } from '@app/core/core.module';
import { GlobalErrorHandler } from '@app/core/errors/error.handler';
import { WorkModule } from '@app/work/work.module';
import { IonicModule } from '@ionic/angular';
import { APP_PROVIDERS } from '@app/core/config/app.init';
import { StoreModule, provideStore } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { IonicStorageModule } from '@ionic/storage-angular';
import { Drivers } from '@ionic/storage';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { coreReducers } from '@app/core/store/core.slice';
import { SharedModule } from './shared/shared.module';
import { PreviewAnyFile } from '@awesome-cordova-plugins/preview-any-file/ngx/index';
import { ProfileEffects } from './profile/store/profile.effects';
import { TranslocoRootModule } from './core/transloco/transloco-root.module';
import { SpotCheck } from 'surveysparrow-ionic-plugin/angular-ui';

@NgModule({
  declarations: [AppContainer],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    WorkModule,
    IonicModule.forRoot({
      backButtonDefaultHref: '',
      swipeBackEnabled: true,
      hardwareBackButton: true,
      scrollPadding: false,
      scrollAssist: true,
      innerHTMLTemplatesEnabled: true,
      backButtonText: null,
      backButtonIcon: 'arrow-back-outline'
    }),
    IonicStorageModule.forRoot({
      name: '__covebo',
      driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
    }),
    StoreModule.forRoot(coreReducers, {
      metaReducers: !environment.production ? [] : [],
      runtimeChecks: {
        strictActionImmutability: true,
        strictStateImmutability: true,
      },
    }),
    EffectsModule.forRoot([ProfileEffects]),
    !environment.production ? StoreDevtoolsModule.instrument({ connectInZone: true }) : [],
    FontAwesomeModule,
    TranslocoRootModule,
    SpotCheck
],
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    APP_PROVIDERS,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    PreviewAnyFile,
    provideStore(coreReducers, {
      metaReducers: !environment.production ? [] : [],
      runtimeChecks: {
        strictActionImmutability: true,
        strictStateImmutability: true,
      },
    })
  ],
  bootstrap: [AppContainer],
})
export class AppModule {}
